export const staticData = (data: any) => {
  const { navData, announcementData, browserLanguageMicrocopySet, featuredSliderData } = data

  const announcement = announcementData?.length
    ? {
        allContentfulComponentAnnouncement: {
          edges: announcementData.announcementData.map((announcement: any) => {
            return { node: announcement }
          }),
        },
      }
    : []

  const featuredSlider = featuredSliderData?.map((entry: any) => entry) || []

  const mainNavBanner = navData?.mainNavBanner?.length
    ? {
        allContentfulComponentMainNavBanner: {
          edges: navData.mainNavBanner.map((entry: any) => {
            return { node: entry }
          }),
        },
      }
    : []

  const header = navData?.headerData
    ? {
        allContentfulMicrocopySet: {
          edges:
            navData?.navigationMicrocopy?.map((microcopySet: any) => {
              return { node: microcopySet }
            }) || [],
        },
        allContentfulNavMenu: {
          nodes: [navData.headerData],
        },
      }
    : []

  const minHeader = navData?.headerData
    ? {
        allContentfulNavMenu: {
          nodes: [navData.headerData],
        },
      }
    : null

  const footer = navData?.footerData
    ? {
        allContentfulNavMenu: {
          nodes: [navData.footerData],
        },
      }
    : null

  const browserLanguage =
    Object.keys(browserLanguageMicrocopySet).length > 0
      ? {
          contentfulMicrocopySet: browserLanguageMicrocopySet,
        }
      : null

  return {
    announcement,
    mainNavBanner,
    featuredSlider,
    header,
    minHeader,
    footer,
    browserLanguage,
  }
}
